import React, { useRef } from 'react';
import { HotTable } from '@handsontable/react';
import 'handsontable/dist/handsontable.full.css';

export function SpreadsheetComponent({ data, onDataChange }) {
  const hotTableComponent = useRef(null);

  const handleSpreadsheetChange = (changes) => {
    if (changes) {
      const newData = [...data];
      changes.forEach(([row, col, oldValue, newValue]) => {
        newData[row][col] = newValue;
      });
      onDataChange(newData);
    }
  };

  return (
    <div style={{ height: '400px', overflow: 'hidden' }}>
      <HotTable
        ref={hotTableComponent}
        data={data}
        colHeaders={true}
        rowHeaders={true}
        height="100%"
        licenseKey="non-commercial-and-evaluation"
        afterChange={handleSpreadsheetChange}
        settings={{
          stretchH: 'all',
          width: '100%',
          autoWrapRow: true,
          autoWrapCol: true,
          manualColumnResize: true,
          manualRowResize: true,
          contextMenu: true,
          filters: true,
          dropdownMenu: true,
        }}
      />
    </div>
  );
}

export default SpreadsheetComponent; 